import { HealthStatus } from '../../services/integrationHealthApi';

// Classe visual do StatusTag por estado. As classes vêm de
// components/common/StatusTag.tsx.
export const STATUS_TAG_CLASS: Record<HealthStatus, string> = {
  operational: 'green',
  degraded: 'orange',
  unavailable: 'red',
  unknown: 'neutral-blue',
};

export const STATUS_LABEL: Record<HealthStatus, string> = {
  operational: 'Operacional',
  degraded: 'Degradado',
  unavailable: 'Indisponível',
  unknown: 'Desconhecido',
};

// Cor de acento (barra lateral do card e ponto do resumo). Usa os tokens de
// globalStyles para manter a tela dentro do sistema visual do PMIS.
export const STATUS_ACCENT: Record<HealthStatus, string> = {
  operational: 'var(--success-medium)',
  degraded: 'var(--warning-dark)',
  unavailable: 'var(--error-medium)',
  unknown: 'var(--neutral_light)',
};

// Situação geral a partir dos cards visíveis. O pior estado presente manda,
// mas `unknown` não rebaixa o geral — a tela esconde plataforma/infra, e um
// not_applicable de parceiro não pode pintar o topo de cinza.
export function worstStatus(statuses: HealthStatus[]): HealthStatus {
  if (statuses.includes('unavailable')) return 'unavailable';
  if (statuses.includes('degraded')) return 'degraded';
  if (statuses.includes('operational')) return 'operational';
  return 'unknown';
}

// Rótulo humano de cada razão. Sem i18n no front (não há biblioteca): textos
// em pt-BR direto. O mapeamento razão -> estado NÃO vive aqui — ele é do
// backend (HealthReason), e a tela só recebe o status já resolvido, para que a
// cor do card nunca possa divergir do significado.
export const REASON_LABEL: Record<string, string> = {
  ok: 'Operando normalmente',
  slow: 'Resposta acima do normal',
  rate_limited: 'Limite de requisições atingido (429)',
  failover: 'Rodando na URL de contingência',
  stale: 'Dado parado — a atualização não está chegando',
  cert_expiring: 'Certificado perto de vencer',
  timeout: 'Tempo limite excedido',
  connection_error: 'Falha de conexão',
  server_error: 'Erro no serviço (5xx)',
  unauthenticated: 'Falha de autenticação ou certificado',
  rejected: 'Requisição recusada por validação',
  never_checked: 'Ainda não verificado',
  stale_probe: 'Sem verificação recente',
  misconfigured: 'Configuração ausente ou inválida',
  not_applicable: 'Não se aplica a este ambiente',
  probe_error: 'Erro na própria verificação',
  // APIs que expomos: aqui saúde é "o parceiro está nos chamando, e com que
  // taxa de erro". `stale_probe` era emprestado para o silêncio do parceiro, e
  // dizia "Sem verificação recente" — um problema NOSSO de monitoramento em vez
  // do fato real.
  no_recent_activity: 'Sem chamadas no período',
  high_error_rate: 'Taxa de erro alta nas chamadas',
  mostly_failing: 'Maioria das chamadas falhando',
  // Entregas que saem por e-mail, não por API: o XML da ANTAQ. Cobre as duas
  // metades — o arquivo não foi gerado, ou foi gerado e o e-mail não saiu.
  delivery_failed: 'Última entrega não foi concluída',
};

export function reasonLabel(reason: string): string {
  return REASON_LABEL[reason] || reason;
}

// "Órgão externo" / "Entregamos" / "Plataforma" já vêm no group.label; a
// direção é um detalhe fino exibido no card.
export const DIRECTION_LABEL: Record<string, string> = {
  inbound_data: 'Consumimos dados',
  outbound_data: 'Enviamos dados',
  platform: 'Infraestrutura',
};

export const MODE_LABEL: Record<string, string> = {
  active: 'verificação ativa',
  passive: 'sinal passivo',
  hybrid: 'híbrido',
};
